import {ObjectUtil} from '../util/object-util';
import {ProposalStatus} from '../enum/proposal-status';
import {LineOfBusiness} from './proposal/line-of-business';

export class ProposalTile {
  id: string = null;
  userId: string = null;
  bookmarked: boolean = false;
  creationDate: Date = null;
  seatNumber: string = null;
  firstName: string = null;
  companyName: string = null;
  userType: string = null;
  lastName: string = null;
  riskDateBegin: Date = null;
  riskDateEnd: Date = null;
  proposalName: string = null;
  lineOfBusiness: LineOfBusiness = null;
  lineOfBusinessSubcategory: string = null;
  coverage: number = null;
  deadline: Date = null;
  insuredAmount: number = null;
  insuredAmountCurrency: string = null;
  insuredSumType: string = null;
  annualSalesAmount: number = null;
  status: ProposalStatus = null;
  numberOfOffersCreated = 0;

  privateProposal: boolean = null;
  usersAllowedToView: string[] = [];

  // a front end only property to animate a disappearing tile
  hideTile = false;

  lastTimeEdited: Date = null;

  constructor(object?: any) {
    ObjectUtil.assign(this, object, [
      "creationDate",
      "riskDateBegin",
      "riskDateEnd",
      "deadline",
    ]);
  }
}
